export default {
  total_co2_saved: 'Totalt har dere spart over %{co2} kgCO\u2082e',
  total_co2_potential_saving: 'Du kan spare %{co2} kgCO\u2082e per år',
  total_co2_footprint: 'Ditt fotavtrykk er %{co2} kgCO\u2082e',
  average_co2_footprint:
    'Gjennomsnittlig fotavtrykk i %{sectionName} er %{co2} kgCO\u2082e',
  average_saving:
    'I gjennomsnitt har hver deltaker spart %{translateCo2} kgCO\u2082e',
  congratulations: 'Gratulerer!',
  reached_new_level: 'Ditt lag har nådd et nytt nivå.',
  vehicles: {
    car: 'bil',
    plane: 'fly',
    train: 'tog',
  },
  transport_methods: {
    car: 'å kjøre',
    plane: 'en flytur',
    train: 'en togreise',
  },
  transport_text: {
    saving_equivalent_to:
      'Denne besparelsen tilsvarer en reise på %{convertedDistance} km med %{vehicle}. Dette er omtrent det samme som %{transportMethod} fra %{from} til %{to}. ',
    footprint_equivalent_to:
      'Dine utslipp tilsvarer en reise på %{convertedDistance}km  med %{vehicle}. Dette er omtrent det samme som %{transportMethod} fra %{from} til %{to}. ',
    actual_distance:
      'Faktisk avstand mellom %{from} og %{to} er %{actualDistance}km',
  },
  locations: {
    copenhagen: 'København',
    london: 'London',
    malmo: 'Malmø',
    rotterdam: 'Rotterdam',
    hague: 'Haag',
    nice: 'Nice',
    cannes: 'Cannes',
    brighton: 'Brighton',
    vienna: 'Wien',
    bratislava: 'Bratislava',
    amsterdam: 'Amsterdam',
    brussels: 'Brussel',
    budapest: 'Budapest',
    glasgow: 'Glasgow',
    paris: 'Paris',
    berlin: 'Berlin',
    cairo: 'Kairo',
    jerusalem: 'Jerusalem',
    barcelona: 'Barcelona',
    madrid: 'Madrid',
    marrakech: 'Marrakesh',
    lisbon: 'Lisboa',
    rome: 'Roma',
    oslo: 'Oslo',
    narvik: 'Narvik',
    vardo: 'Vardø',
    prague: 'Praha',
    athens: 'Athen',
    moscow: 'Moskva',
    istanbul: 'Istanbul',
    tromso: 'Tromsø',
    singapore: 'Singapore',
    seattle: 'Seattle',
    miami: 'Miami',
    nairobi: 'Nairobi',
    dubai: 'Dubai',
    anchorage: 'Anchorage',
    ulaanbaatar: 'Ulaanbaatar',
    magadan: 'Magadan',
    las_vegas: 'Las Vegas',
    new_dehli: 'New Delhi',
    new_delhi: 'New Delhi',
    cape_town: 'Cape Town',
    new_york: 'New York',
    hakone: 'Hakone',
    tsuru: 'Tsuru',
    kashima: 'Kashima',
    joetsu: 'Joetsu',
    hamamatsu: 'Hamamatsu',
    aizuwakamatsu: 'Aizuwakamatsu',
    kyoto: 'Kyoto',
    kobe: 'Kobe',
    morioka: 'Morioka',
    izumo: 'Izumo',
    imabari: 'Imabari',
    hakodate: 'Hakodate',
    hiroshima: 'Hiroshima',
    sapporo: 'Sapporo',
    shimonoseki: 'Shimonoseki',
    shanghai: 'Shanghai',
    miyakojima: 'Miyakojima',
    dalian: 'Dalian',
    guam: 'Guam',
    hong_kong: 'Hong Kong',
    taipei: 'Taipei',
    hanoi: 'Hanoi',
    cebu: 'Cebu',
    ho_chi_minh_city: 'Ho Chi Minh City',
    brunei: 'Brunei',
    bangkok: 'Bangkok',
    honolulu: 'Honolulu',
    agra: 'Agra',
    ayers_rock: 'Ayers Rock',
    melbourne: 'Melbourne',
    san_francisco: 'San Francisco',
    trondheim: 'Trondheim',
    la_habana: 'Havana',
    sahara: 'Sahara',
    antarctica: 'Antarctica',
    quito: 'Quito',
    rio_de_janeiro: 'Rio de Janeiro',
    tokyo: 'Tokyo',
    manchester: 'Manchester',
    liverpool: 'Liverpool',
    luton: 'Luton',
    cambridge: 'Cambridge',
    oxford: 'Oxford',
    cardiff: 'Cardiff',
    sheffield: 'Sheffield',
    newcastle_upon_tyne: 'Newcastle upon Tyne',
    inverness: 'Inverness',
    john_o_groats: "John O' Groats",
    lands_end: "Land's End",
  },
  energy_text: {
    small_usage: {
      saving_equivalent_to:
        'Denne besparelsen tilsvarer %{convertedKwh}kWh. Dette er omtrent det samme som å bruke din %{appliance} i %{quantity} %{units}!',
      footprint_equivalent_to:
        'Dine utslipp tilsvarer %{convertedKwh}kWh. Dette er omtrent det samme som å bruke din %{appliance} i %{quantity} %{units}!',
      actual_energy_used:
        'Faktisk energiforbruk for %{appliance} i %{quantity} %{units} er %{actualKwh}kWh.',
      saving_equivalent_to_times:
        'Denne besparelsen tilsvarer %{convertedKwh}kWh. Dette er omtrent det samme som å bruke %{appliance} %{quantity} %{units}!',
      footprint_equivalent_to_times:
        'Dine utslipp tilsvarer %{convertedKwh}kWh. Dette er omtrent det samme som å bruke %{appliance} %{quantity} %{units}!',
      actual_energy_used_times:
        'Faktisk energiforbruk av en gjennomsnittlig %{appliance} %{quantity} %{units} er %{actualKwh}kWh.',
    },
    large_usage: {
      saving_equivalent_to:
        'Denne besparelsen tilsvarer %{convertedKwh}kWh. Dette er omtrent det samme som det hele %{appliance} bruker i %{quantity} %{units}!',
      footprint_equivalent_to:
        'Dine utslipp tilsvarer %{convertedKwh}kWh. Dette er omtrent det samme som det hele %{appliance} bruker i %{quantity} %{units}!',
      actual_energy_used:
        'Gjennomsnittlig energiforbruk for %{appliance} i %{quantity} %{units} er %{actualKwh}kWh.',
    },
    production: {
      saving_equivalent_to:
        'Denne besparelsen tilsvarer %{convertedKwh}kWh. Dette er omtrent så mye energi en %{appliance} produserer i %{quantity} %{units}.',
      footprint_equivalent_to:
        'Dine utslipp tilsvarer %{convertedKwh}kWh. Dette er omtrent så mye energi en %{appliance} produserer i %{quantity} %{units}.',
      actual_energy_used:
        'Gjennomsnittlig energiforbruk for en %{appliance} i %{quantity} %{units} er %{actualKwh}kWh.',
    },
  },
  appliances: {
    microwave: 'mikrobølgeovn',
    plasma_tv: 'flatskjerm TV',
    clothes_dryer: 'tørketrommel',
    lawnmower: 'gressklipper',
    portable_heater: 'ovn',
    oven: 'ovn',
    hair_dryer: 'hårføner',
    desktop_computer: 'stasjonær PC',
    dishwasher: 'oppvaskmaskin',
    vacuum_cleaner: 'støvsuger',
    coffee_brewer: 'kaffemaskin',
    total_household: 'hus',
    stereo: 'stereo',
    playstation_tv: 'PS4 og fjernsyns TV',
    windmill: 'vindmølle',
    laptop: 'laptop',
  },
  units: {
    times: 'ganger',
    hours: 'timer',
    days: 'dager',
    years: 'år',
  },
  nature_text: {
    10: 'Dette tilsvarer like mye som 1 tre absorberer\npå et år',
    25: 'Dette tilsvarer omtrent samme mengde som 30 trær absorberer på en måned.',
    50: 'Dette tilsvarer omtrent samme mengde som 60 trær absorberer på en måned."',
    100: 'Dette tilsvarer omtrent samme mengde som 120 trær absorberer på en måned.',
    150: 'Dette tilsvarer omtrent det 181 trær absorberer på en måned.',
    200: 'Dette tilsvarer omtrent samme mengde som 240 trær absorberer på en måned.',
    300: 'Dette tilsvarer omtrent samme mengde som 361 trær absorberer på en måned.',
    500: 'Dette tilsvarer omtrent det et skogsområde på 8428 m\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på kjøpesenteret Trondheim Torg.',
    1000: 'Dette tilsvarer omtrent et skogsområde på 16884 m\u00B2 som er tilnærmet lik gulvarealet på slottet.',
    1500: 'Dette tilsvarer om lag et skogsområde på 25301 m\u00B2 som er omtrent like stort som Vikingskipet på Hamar.',
    2000: 'Dette tilsvarer omtrent det et skogsområde på 33735 m\u00B2 absorberer i løpet av en måned som er på størrelse med gulvarealet av Operaen i Bjørvika.',
    2500: 'Dette tilsvarer omtrent det et skogsområde på 42169 m\u00B2 absorberer på en måned, som er omtrent like stort som gulvarealet i Oslo Rådhus.',
    3000: 'Dette tilsvarer omtrent et skogsområde på 50602 m\u00B2 som er nesten like gulvarealet av Det Hvite Hus.',
    4000: 'Dette tilsvarer omtrent et skogsområde på 67470 m\u00B2 som kan sammenliknes med gulvarealet av Louvre i Paris, verdens største museum.',
    6000: 'Dette tilsvarer omtrent det et skogsområde på 0,10 km\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på nye Flesland i Bergen.',
    8000: 'Dette tilsvarer omtrent det et skogsområde på 0,13 km\u00B2 absorberer i løpet av en måned, som er tilnærmet lik 2x gulvarealet til Louvre i Paris.',
    10000:
      'Dette tilsvarer omtrent det et skogsområde på 0,17 km\u00B2 absorberer i løpet av en måned, som er på størrelse med Akershus Festning.',
    12000:
      'Dette tilsvarer omtrent det et skogsområde på 0,20 km\u00B2 absorberer i løpet av en måned, som er på størrelse med Tøyenparken i Oslo.',
    14000:
      'Dette tilsvarer omtrent det et skogsområde på 0,24 km\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på Hunderfossen Familiepark i Lillehammer.',
    16000:
      'Dette tilsvarer omtrent det et skogsområde på 0,27 km\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på nye Oslo Gardermoen.',
    20000:
      'Dette tilsvarer omtrent det et skogsområde på 0,33 km\u00B2 absorberer i løpet av en måned, noe som er nesten like stort som 2x Akershus Festning.',
    25000:
      'Dette tilsvarer omtrent det et skogsområde på 0,42 km\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på Vatikanstaten.',
    30000:
      'Dette tilsvarer omtrent det et skogsområde på 0,50 km\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på Frognerparken.',
    35000:
      'Dette tilsvarer omtrent det et skogsområde på 0,59 km\u00B2 absorberer i løpet av en måned, som er på størrelse med Tusenfryd.',
    40000:
      'Dette tilsvarer omtrent det et skogsområde på 0,67 km\u00B2 absorberer i løpet av en måned, som kan sammenlignes med størrelsen på Dyreparken i Kristiansand.',
  },
  actual_area: {
    500: {
      place: 'kjøpesenteret Trondheim Torg',
      size: '8428 m\u00B2',
    },
    1000: {
      place: 'Kristiansten Festning',
      size: '16884 m\u00B2',
    },
    1500: {
      place: 'Vikingskipet',
      size: '25301 m\u00B2',
    },
    2000: {
      place: 'Operaen',
      size: '33735 m\u00B2',
    },
    2500: {
      place: 'Oslo Rådhus',
      size: '42169 m\u00B2',
    },
    3000: {
      place: 'Det Hvite Hus',
      size: '50602 m\u00B2',
    },
    4000: {
      place: 'Det Louvre',
      size: '67470 m\u00B2',
    },
    6000: {
      place: 'Flesland',
      size: '0.10 km\u00B2',
    },
    8000: {
      place: 'to Louvres',
      size: '0.13 km\u00B2',
    },
    10000: {
      place: 'Akershus slott',
      size: '0.17 km\u00B2',
    },
    12000: {
      place: 'Tøyenparken',
      size: '0.20 km\u00B2',
    },
    14000: {
      place: 'Hunderfossen Familiepark',
      size: '0.224 km\u00B2',
    },
    16000: {
      place: 'Oslo Gardermoen',
      size: '0.227 km\u00B2',
    },
    20000: {
      place: 'to Akershus slottet',
      size: '0.33 km\u00B2',
    },
    25000: {
      place: 'Vatikanstaten.',
      size: '0.42 km\u00B2',
    },
    30000: {
      place: 'Frognerparken',
      size: '0.50 km\u00B2',
    },
    35000: {
      place: 'Tusenfryd',
      size: '0.59 km\u00B2',
    },
    40000: {
      place: 'Dyreparken',
      size: '0.67 km\u00B2',
    },
  },
  static: {
    car_low: {
      title: 'Totalt har du spart %{kg}kg CO\u2082e',
      title_collective: 'Totalt har dere spart %{kg}kg CO\u2082e',
      body: 'Dette er det samme som å reise %{distance}km med bil, som er omtrent det samme som å kjøre bil fra København til Malmö %{times} ganger.',
      actual: 'Den faktiske avstanden mellom København og Malmö er 44.4km',
    },
    car_med: {
      title: 'Totalt har du spart %{kg}kg CO\u2082e',
      title_collective: 'Totalt har dere spart %{kg}kg CO\u2082e',
      body: 'Dette er det samme som å reise %{distance}km med bil, som er omtrent det samme som å kjøre bil fra Roma til Budapest %{times} ganger.',
      actual: 'Den faktiske avstanden mellom Roma og Budapest er 1485km',
    },
    appliance_low: {
      title: 'Totalt har du spart %{kg}kg CO\u2082e',
      title_collective: 'Totalt har du spart %{kg}kg CO\u2082e',
      body: 'Dette tilsvarer %{kWh}kWh med energi, som er omtrent det samme som å bruke mikroovnen i %{days} dager.',
      actual: '',
    },
    plane_high: {
      title: 'Totalt har du spart %{kg}kg CO\u2082e',
      title_collective: 'Totalt har dere spart %{kg}kg CO\u2082e',
      body: 'Dette er det samme som å reise %{distance}km med fly, som er omtrent det samme som å fly rundt jorden %{times} gang. |||| Dette er det samme som å reise %{distance}km med fly, som er omtrent det samme som å fly rundt jorden %{times} ganger.',
      actual: 'Den faktiske avstanden rundt jorda er 40 076km',
    },
  },
};
